import React from 'react'
import css from './style.scss'
import {Page} from './background'

const Feature=(props)=>(
  <div className={css.feature}>
    <div className={css.feature_text}>
      <h2 className={css.feature_title}>{props.title}</h2>
      <p className={css.feature_description}>{props.children}</p>
    </div>
    <div className={css.feature_image}><img alt={props.title} src={process.env.REACT_APP_URL+"/assets/homepage/"+props.image}></img></div>
  </div>
)

export default (props)=>(
  <Page>
    <div id="features" className={css.features}>
      <Feature title="Backup all your Instagram Stories." image="backup.png">
        Archive and access all your Instagram Stories from any device. Yes, also that video you shared 3 months ago. 
      </Feature>
      <Feature title="Analyze and monitor the performance of your Stories" image="analyze.png">
        View every Story’s impressions, users reached, taps forward and much more. We will help you get the most from it. 
      </Feature>
      <Feature title="Invite your friends (or colleagues) too!" image="share.png">
      Someone is helping you with your Instagram profile? Are you a brand? Share your Stories’ insights with your collaborators.
      </Feature>
      <Feature title="Export everything" image="export.png">
        These are your Instagram Stories: you can download all your data whenever you want.
      </Feature>
    </div>
  </Page>
)



// WEBPACK FOOTER //
// ./src/components/home_page/landing/sections/features.js